import styled, { keyframes } from "styled-components";
import { blackColor, darkColor, greenColor } from "../../constants/colors";

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const translateAnimation = keyframes`
  0% {
    transform: translateX(-150%);
    opacity: 0;
  }
  12% {
    transform: translateX(0);
    opacity: 1;
  }
  
  88% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-150%);
  }
`;

const AnalyzeBlock = styled.div`
  padding-top: 53px;
  padding-bottom: 75px;
  //min-height: 100vh;
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

AnalyzeBlock.Title = styled.div`
  margin-bottom: 30px;
  h3 {
    color: ${blackColor};
  }
`;
AnalyzeBlock.Items = styled.div`
  margin-bottom: 67px;
`;
AnalyzeBlock.Item = styled.div`
  margin-bottom: 16px;
`;
AnalyzeBlock.Item.Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 9px;
`;
AnalyzeBlock.Item.Top.Left = styled.div`
  p {
    color: ${blackColor};
  }
`;
AnalyzeBlock.Item.Top.Right = styled.div`
  p {
    animation: ${fadeInAnimation} 1s ease-in-out forwards;
  }
`;
AnalyzeBlock.Item.Bottom = styled.div``;
AnalyzeBlock.Item.Line = styled.div`
  height: 14px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
`;
AnalyzeBlock.Item.Loading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 10px;
  animation: ${fadeInAnimation} 1s ease-in-out forwards;
  transition: 0.1s;
`;
AnalyzeBlock.Subtitle = styled.div``;
AnalyzeBlock.Ok = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  background: ${greenColor};
  animation: ${fadeInAnimation} 0.5s ease-in-out forwards;
`;
AnalyzeBlock.Comments = styled.div`
  overflow: hidden;
`;
AnalyzeBlock.Comments.Items = styled.div``;
AnalyzeBlock.Comments.Item = styled.div`
  background: #efefef;
  padding: 25px 27px 20px 25px;
  border-radius: 16px;
  animation: ${translateAnimation} 8s ease-in-out infinite forwards;
`;
AnalyzeBlock.Comments.Item.Top = styled.div`
  margin-bottom: 11px;
`;
AnalyzeBlock.Comments.Item.Text = styled.div`
  margin-bottom: 24px;
`;
AnalyzeBlock.Comments.Item.Name = styled.div``;

export { AnalyzeBlock };
